import { JsonDateParser } from "../../../../../react-core/Utils/JsonDateParser";
import { ProcessType as ActivityType } from "../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";
import { UserClaim } from "../../../../../Wrap/Constants/Enums/UserClaim";
import { Workflow } from "../../../../../Wrap/Models/Domains/Workflow/Workflow";
import { HierarchyIdHelper } from "../../../../Shared/Common/HierarchyIdHelper";

import { ProcessType } from "../../../../Shared/IST/Resource/Content";
import { checkPermission } from "../../../../Shared/Permission/PermissionHelper";
import { StaticUrls } from "../../../Resoures/StaticUrls";
import { NewBusinessAction } from "../../Clients/NewBusinessWizard/Actions/NewBusinessAction";
import { NewQuoteAction } from "../../Clients/NewQuoteWizard/Actions/NewQuoteAction";
import { SPTAction } from "../../Clients/SinglePaymentTransferWizard/Actions/SPTActions";

export const onDateSelectChange = (key: string) => {
    let beginDate: Date = null;
    let endDate: Date = null;
    let fromYear = null;
    let toYear = null;
    const now = new Date();
    const nowStr = JsonDateParser.getFormatDateString(now, "yyyy/MM/dd").split("/");
    const pointDate = new Date(Number(nowStr[0]), 3, 6);

    switch (key) {
        case "Past tax year":
            if (now > pointDate) {
                fromYear = Number(nowStr[0]) - 1;
                toYear = Number(nowStr[0]);
                beginDate = new Date(fromYear, 3, 6);
                endDate = new Date(toYear, 3, 5);
            } else {
                fromYear = Number(nowStr[0]) - 2;
                toYear = Number(nowStr[0]) - 1;
                beginDate = new Date(fromYear, 3, 6);
                endDate = new Date(toYear, 3, 5);
            }
            break;
        case "Current tax year": //"Current tax year"
            if (now > pointDate) {
                fromYear = Number(nowStr[0]);
                beginDate = new Date(fromYear, 3, 6);
                endDate = now;
            } else {
                fromYear = Number(nowStr[0]) - 1;
                beginDate = new Date(fromYear, 3, 6);
                endDate = now;
            }
            break;
        case "Custom": //"Custom"
            beginDate = getPastYear(now);
            endDate = now;
            break;
        case "Past year": //"Past year"
            beginDate = getPastYear(now);
            endDate = now;
            break;
        case "Past 6 months": //"Past 6 months"
            beginDate = isLeapDay(now)
                ? new Date(now.getFullYear() - 1, 8, 1)
                : new Date(now.getFullYear(), now.getMonth() - 6, now.getDate() + 1);
            endDate = now;
            break;
        case "Past 3 months":
            beginDate = isLeapDay(now)
                ? new Date(now.getFullYear() - 1, 12, 1)
                : new Date(now.getFullYear(), now.getMonth() - 3, now.getDate() + 1);
            endDate = now;
            break;
        case "Past month":
            beginDate = isLeapDay(now)
                ? new Date(now.getFullYear(), 2, 1)
                : new Date(now.getFullYear(), now.getMonth() - 1, now.getDate() + 1);
            endDate = now;
            break;
    }
    return { optionKey: key, fromDateSelected: beginDate, toDateSelected: endDate };
};

export const isLeapDay = (endDate: Date) => {
    const year = endDate.getFullYear();
    const isLeapYear = year % 100 === 0 ? year % 400 === 0 : year % 4 === 0;
    const leapdaystr = endDate.getFullYear() + "/02/29";
    const todaystr = JsonDateParser.getFormatDateString(endDate, "yyyy/MM/dd");
    return isLeapYear && todaystr === leapdaystr;
};

export const getPastYear = (endDate: Date): Date => {
    return isLeapDay(endDate)
        ? new Date(endDate.getFullYear() - 1, 2, 1)
        : new Date(endDate.getFullYear() - 1, endDate.getMonth(), endDate.getDate() + 1);
};

export const switchCancel = (activityType: ActivityType, instructionId, callback, wizardId, accountId?) => {
    switch (activityType) {
        case ActivityType.Quote:
        case ActivityType.NewQuoteExistingClient:
            NewQuoteAction.deleteQuoteInstruction(instructionId, callback);
            break;
        case ActivityType.NewBusiness:
            NewBusinessAction.cancleApplyInstruction(instructionId, accountId, callback);
            break;
        case ActivityType.NewBusinessExistingClient:
            NewBusinessAction.cancleApplyInstruction(instructionId, null, callback);
            break;
        case ActivityType.ExistingClientNewBusiness:
            NewBusinessAction.cancelExistingClientWizard(wizardId, callback);
            break;
        case ActivityType.Topup:
        case ActivityType.TakePensionBenefit:
        case ActivityType.AddSinglePaymentorTransfer:
        case ActivityType.AddRegularPayment:
        case ActivityType.EditRegularPayment:
        case ActivityType.WhatIfTool:
        case ActivityType.OneoffIncomePayments:
        case ActivityType.EditIncomeWithdrawals:
        case ActivityType.ConvertCappedToFlexi:
        case ActivityType.EditIncomeDrawdown:
        case ActivityType.GADReview:
            SPTAction.deleteInstruction(instructionId, callback);
        default:
            instructionId > 0 && wizardId > 0 ? NewBusinessAction.cancelExistingClientWizard(wizardId, callback) : null;
            return;
    }
};

export const switchResume = (activityType: ActivityType, row: Workflow): string => {
    switch (activityType) {
        case ActivityType.Quote:
            return checkPermission(UserClaim.AdviserPortalNewQuoteNewBusinessReadWrite)
                ? StaticUrls.WrapperSelectionUrl(row.CustomerId.toString(), row.ReferenceNumber, ProcessType.Quote)
                : null;
        case ActivityType.NewQuoteExistingClient:
            return checkPermission(UserClaim.AdviserPortalNewQuoteNewBusinessReadWrite)
                ? StaticUrls.WrapperSelectionUrl(row.CustomerId.toString(), row.ReferenceNumber, ProcessType.Quote) +
                      "&hierarchyid=" +
                      row.AccountHierarchyId
                : null;
        case ActivityType.NewBusiness:
            return checkPermission(UserClaim.AdviserPortalNewQuoteNewBusinessReadWrite)
                ? StaticUrls.FullClientDetailsUrl(row.CustomerId.toString(), row.ReferenceNumber)
                : null;
        case ActivityType.NewBusinessExistingClient:
            return checkPermission(UserClaim.AdviserPortalNewQuoteNewBusinessReadWrite)
                ? StaticUrls.FullClientDetailsUrl(row.CustomerId.toString(), row.ReferenceNumber) +
                      "&hierarchyid=" +
                      row.AccountHierarchyId
                : null;
        case ActivityType.TakePensionBenefit:
            return (
                StaticUrls.PensionBenefitsUrl(
                    row.ProductType.toString(),
                    row.ClAccountId,
                    row.AccountHierarchyId,
                    row.SubAccountHierarchyId,
                    false
                ) +
                `&id=` +
                row.ReferenceNumber
            );
        case ActivityType.AddSinglePaymentorTransfer:
            return checkPermission(UserClaim.AdviserPortalSPTAndRegularPaymentReadWrite)
                ? StaticUrls.SinglePaymentUrl(
                      row.ProductType.toString(),
                      row.ClAccountId,
                      row.AccountHierarchyId,
                      row.SubAccountHierarchyId,
                      false
                  ) +
                      `&id=` +
                      row.ReferenceNumber
                : null;
        case ActivityType.AddRegularPayment:
            return checkPermission(UserClaim.AdviserPortalSPTAndRegularPaymentReadWrite)
                ? StaticUrls.RegularPaymentUrl(
                      row.ProductType.toString(),
                      row.ClAccountId,
                      row.AccountHierarchyId,
                      row.SubAccountHierarchyId,
                      "add",
                      null,
                      false
                  ) +
                      `&id=` +
                      row.ReferenceNumber
                : null;
        case ActivityType.EditRegularPayment:
            return checkPermission(UserClaim.AdviserPortalSPTAndRegularPaymentReadWrite)
                ? StaticUrls.RegularPaymentUrl(
                      row.ProductType.toString(),
                      row.ClAccountId,
                      row.AccountHierarchyId,
                      row.SubAccountHierarchyId,
                      "edit",
                      null,
                      false
                  ) +
                      `&id=` +
                      row.ReferenceNumber
                : null;
        case ActivityType.Topup:
            return (
                StaticUrls.TopupUrl(
                    row.ProductType.toString(),
                    row.ClAccountId,
                    row.AccountHierarchyId,
                    row.SubAccountHierarchyId,
                    false
                ) +
                `&id=` +
                row.ReferenceNumber
            );
        case ActivityType.WhatIfTool:
            return StaticUrls.WhatIfToolUrl(
                row.ProductType.toString(),
                row.ClAccountId,
                row.AccountHierarchyId,
                row.SubAccountHierarchyId,
                null,
                false
            ) +
                `&id=` +
                row.ReferenceNumber;
        case ActivityType.OneoffIncomePayments:
            return StaticUrls.IncomePaymentOneOffUrl(
                row.ProductType.toString(),
                row.ClAccountId,
                row.AccountHierarchyId,
                row.SubAccountHierarchyId,
                false
            ) +
                `&id=` +
                row.ReferenceNumber;
        case ActivityType.EditIncomeWithdrawals:
            return StaticUrls.EditIncomeWithdrawalsUrl(
                row.ProductType.toString(),
                row.ClAccountId,
                row.AccountHierarchyId,
                row.SubAccountHierarchyId,
                false
                ) +
                `&id=` +
                row.ReferenceNumber +
                "&customerid=" +
                row.CustomerId;
        case ActivityType.ConvertCappedToFlexi:
            return StaticUrls.ConvertCappedToFlexiUrl(
                row.ProductType.toString(),
                row.ClAccountId,
                row.AccountHierarchyId,
                row.SubAccountHierarchyId,
                false
            ) +
                `&id=` +
                HierarchyIdHelper.generateHierarchyId(row.ReferenceNumber).entityId;
        case ActivityType.EditIncomeDrawdown:
            return StaticUrls.EditIncomeDrawdownUrl(
                row.ProductType.toString(),
                row.ClAccountId,
                row.AccountHierarchyId,
                row.SubAccountHierarchyId,
                false
            ) +
                `&id=` +
                row.ReferenceNumber;
        case ActivityType.GADReview:
            return StaticUrls.EditGadReviewUrl(
                row.ProductType.toString(),
                row.ClAccountId,
                row.AccountHierarchyId,
                row.SubAccountHierarchyId,
                false
            ) +
                `&id=` +
                row.ReferenceNumber;
        case ActivityType.BedAndProduct:
            return StaticUrls.BedAndProductUrl(
                row.ProductType.toString(),
                row.ClAccountId,
                row.AccountHierarchyId,
                row.SubAccountHierarchyId,
                false
            ) +
                `&id=` +
                row.ReferenceNumber;
        case ActivityType.Switch:
            return StaticUrls.SwitchUrl(
                row.ProductType.toString(),
                row.ClAccountId,
                row.AccountHierarchyId,
                row.SubAccountHierarchyId,
            ) + 
                `&id=` +
                row.ReferenceNumber;
        default:
            return "";
    }
};

export const switchView = (activityType: ActivityType, row: Workflow): string => {
    switch (activityType) {
        case ActivityType.Transfer:
            return checkPermission(UserClaim.AdviserPortalDluReregistrationTransfersCanView)
                ? `/clients/tracking/reregistration-transfers.aspx?claccountid=${row.ClAccountId}&txtStatus=Completed`
                : null;
        case ActivityType.Quote:
            return checkPermission(UserClaim.AdviserPortalNewQuoteNewBusinessReadWrite)
                ? StaticUrls.QuoteReadyUrl(row.CustomerId.toString(), row.ReferenceNumber)
                : null;
        case ActivityType.NewQuoteExistingClient:
            return checkPermission(UserClaim.AdviserPortalNewQuoteNewBusinessReadWrite)
                ? StaticUrls.QuoteReadyUrl(row.CustomerId.toString(), row.ReferenceNumber) +
                      "&hierarchyid=" +
                      row.AccountHierarchyId
                : null;
        case ActivityType.NewBusiness:
            return checkPermission(UserClaim.AdviserPortalNewQuoteNewBusinessReadWrite)
                ? StaticUrls.FullClientDetailsUrl(row.CustomerId.toString(), row.ReferenceNumber, true)
                : null;
        case ActivityType.NewBusinessExistingClient:
            return checkPermission(UserClaim.AdviserPortalNewQuoteNewBusinessReadWrite)
                ? StaticUrls.FullClientDetailsUrl(row.CustomerId.toString(), row.ReferenceNumber, true) +
                      "&hierarchyid=" +
                      row.AccountHierarchyId
                : null;
        case ActivityType.TakePensionBenefit:
            return (
                StaticUrls.PensionBenefitsUrl(
                    row.ProductType.toString(),
                    row.ClAccountId,
                    row.AccountHierarchyId,
                    row.SubAccountHierarchyId,
                    true
                ) +
                `&id=` +
                row.ReferenceNumber
            );
        case ActivityType.AddSinglePaymentorTransfer:
            return checkPermission(UserClaim.AdviserPortalSPTAndRegularPaymentReadWrite)
                ? StaticUrls.SinglePaymentUrl(
                      row.ProductType.toString(),
                      row.ClAccountId,
                      row.AccountHierarchyId,
                      row.SubAccountHierarchyId,
                      true
                  ) +
                      `&id=` +
                      row.ReferenceNumber
                : null;
        case ActivityType.AddRegularPayment:
            return checkPermission(UserClaim.AdviserPortalSPTAndRegularPaymentReadWrite)
                ? StaticUrls.RegularPaymentUrl(
                      row.ProductType.toString(),
                      row.ClAccountId,
                      row.AccountHierarchyId,
                      row.SubAccountHierarchyId,
                      "add",
                      null,
                      true
                  ) +
                      `&id=` +
                      row.ReferenceNumber
                : null;
        case ActivityType.EditRegularPayment:
            return checkPermission(UserClaim.AdviserPortalSPTAndRegularPaymentReadWrite)
                ? StaticUrls.RegularPaymentUrl(
                      row.ProductType.toString(),
                      row.ClAccountId,
                      row.AccountHierarchyId,
                      row.SubAccountHierarchyId,
                      "edit",
                      null,
                      true
                  ) +
                      `&id=` +
                      row.ReferenceNumber
                : null;
        case ActivityType.Topup:
            return (
                StaticUrls.TopupUrl(
                    row.ProductType.toString(),
                    row.ClAccountId,
                    row.AccountHierarchyId,
                    row.SubAccountHierarchyId,
                    true
                ) +
                `&id=` +
                row.ReferenceNumber
            );
        case ActivityType.WhatIfTool:
            return checkPermission(UserClaim.AdviserPortalSPTAndRegularPaymentReadWrite)
                ? StaticUrls.WhatIfToolUrl(
                      row.ProductType.toString(),
                      row.ClAccountId,
                      row.AccountHierarchyId,
                      row.SubAccountHierarchyId,
                      null,
                      true
                  ) +
                      `&id=` +
                      row.ReferenceNumber
                : null;
        case ActivityType.OneoffIncomePayments:
            return StaticUrls.IncomePaymentOneOffUrl(
                row.ProductType.toString(),
                row.ClAccountId,
                row.AccountHierarchyId,
                row.SubAccountHierarchyId,
                true
            ) +
                `&id=` +
                row.ReferenceNumber;
        case ActivityType.EditIncomeWithdrawals:
            return StaticUrls.EditIncomeWithdrawalsUrl(
                row.ProductType.toString(),
                row.ClAccountId,
                row.AccountHierarchyId,
                row.SubAccountHierarchyId,
                true
                ) +
                `&id=` +
                row.ReferenceNumber +
                "&customerid=" +
                row.CustomerId;
        case ActivityType.EditIncomeDrawdown:
            return (
                StaticUrls.EditIncomeDrawdownUrl(
                    row.ProductType.toString(),
                    row.ClAccountId,
                    row.AccountHierarchyId,
                    row.SubAccountHierarchyId,
                    true
                ) +
                `&id=` +
                row.ReferenceNumber
            );
        case ActivityType.GADReview:
            return (
                StaticUrls.EditGadReviewUrl(
                    row.ProductType.toString(),
                    row.ClAccountId,
                    row.AccountHierarchyId,
                    row.SubAccountHierarchyId,
                    true
                ) +
                `&id=` +
                row.ReferenceNumber
            );
        case ActivityType.BedAndProduct:
            return (
                StaticUrls.BedAndProductUrl(
                    row.ProductType.toString(),
                    row.ClAccountId,
                    row.AccountHierarchyId,
                    row.SubAccountHierarchyId,
                    true
                ) +
                `&id=` +
                row.ReferenceNumber
            );
        case ActivityType.BedAndAbrdnProduct:
        return (
            StaticUrls.BedAndAbrdnProductUrl(
                row.ProductType.toString(),
                row.ClAccountId,
                row.AccountHierarchyId,
                row.SubAccountHierarchyId,
                true
            ) +
            `&id=` +
            row.ReferenceNumber
        );
        case ActivityType.ConvertCappedToFlexi:
            return (
                StaticUrls.ConvertCappedToFlexiUrl(
                    row.ProductType.toString(),
                    row.ClAccountId,
                    row.AccountHierarchyId,
                    row.SubAccountHierarchyId,
                    true
                ) +
                `&id=` +
                HierarchyIdHelper.generateHierarchyId(row.ReferenceNumber).entityId
            );
        case ActivityType.Switch:
            return (
                StaticUrls.SwitchUrl(
                    row.ProductType.toString(),
                    row.ClAccountId,
                    row.AccountHierarchyId,
                    row.SubAccountHierarchyId,
                    true
                ) +
                `&id=` +
                row.ReferenceNumber
            );
        default:
            return "";
    }
};
